import "./InputText.css";

import JoditEditor from "jodit-react";

const InputText = ({
  labelinput,
  textArea = false,
  white,
  name,
  value = "",
  handleChange,
  champs,
  readOnly = false,
  placeholder,
  type = "text",
}) => {
  return (
    <div className="text-start pt-2 pb-2 w-100">
      {labelinput && <label className="f16">{labelinput}</label>}
      <div className="d-flex align-items-center gap-2">
        {/*   {flag && <div className={`flagInput rounded-3 ${focused}`}></div>} */}

        {textArea ? (
          <JoditEditor
            readOnly={readOnly}
            value={value}
            onChange={(e) => handleChange(e, champs)}
          />
        ) : (
          <input
            value={value || ""}
            readOnly={readOnly}
            placeholder={placeholder}
            type={type}
            onChange={(e) => handleChange(e.target.value, champs)}
            // name={name}
            className={`styleInput w-100 ps-3 rounded-3 ${
              white ? "bg-white" : ""
            }`}
          />
        )}
      </div>
    </div>
  );
};

export default InputText;
